import { NgModule, ModuleWithProviders, Provider } from "@angular/core";
import { RouterModule } from "@angular/router";
import {
  DateAdapter,
  NativeDateAdapter,
  MatDateFormats,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material";
import { FlexLayoutModule } from "@angular/flex-layout";

import { CoreModule, AuthGuard, MainConfig } from "./core";
import { AddButtonModule } from "./add-button/add-button.module";
import { AdministratorsModule } from "./administrators/administrators.module";
import { ArrayBoxModule } from "./array-box/array-box.module";
import { ArrayExpansionBoxModule } from "./array-expansion-box/array-expansion-box.module";
import { ColorInputModule } from "./color-input/color-input.module";
import { CrudBoxModule } from "./crud-box/crud-box.module";
import { ListCrudBoxModule } from "./list-crud-box/list-crud-box.module";
import { DatagridModule } from "./datagrid/datagrid.module";
import { FileInputModule } from "./file-input/file-input.module";
import { ImageInputModule } from "./image-input/image-input.module";
import { InputErrorModule } from "./input-error/input-error.module";
import { LayoutModule } from "./layout/layout.module";
import { ListBoxModule } from "./list-box/list-box.module";
import { LoginModule } from "./login/login.module";
import { YoutubePlayerModule } from "./youtube-player/youtube-player.module";
import { NotifyModule } from "./notify/notify.module";
import { CurrentLocaleCodeModule } from "./current-locale-code/current-locale-code.module";

const ATENEA_MODULES = [
  AddButtonModule,
  AdministratorsModule,
  CoreModule,
  ArrayBoxModule,
  ArrayExpansionBoxModule,
  ColorInputModule,
  CrudBoxModule,
  DatagridModule,
  FileInputModule,
  ImageInputModule,
  InputErrorModule,
  LayoutModule,
  ListBoxModule,
  LoginModule,
  YoutubePlayerModule,
  NotifyModule,
  CurrentLocaleCodeModule,
];

export const MD_NATIVE_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: null,
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: { year: "numeric", month: "short" },
    dateA11yLabel: { year: "numeric", month: "long", day: "numeric" },
    monthYearA11yLabel: { year: "numeric", month: "long" },
  },
};

@NgModule({
  imports: [
    RouterModule.forRoot([]),
    AddButtonModule,
    AdministratorsModule,
    CoreModule,
    ArrayBoxModule,
    ArrayExpansionBoxModule,
    CrudBoxModule,
    DatagridModule,
    FileInputModule,
    ImageInputModule,
    InputErrorModule,
    LayoutModule,
    ListBoxModule,
    LoginModule,
    YoutubePlayerModule,
    FlexLayoutModule,
    NotifyModule,
    CurrentLocaleCodeModule,
  ],
  exports: ATENEA_MODULES,
  providers: [
    AuthGuard,
    { provide: DateAdapter, useClass: NativeDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: "es-ES" },
    { provide: MAT_DATE_FORMATS, useValue: MD_NATIVE_DATE_FORMATS },
  ],
})
export class AteneaModule {
  static forRoot(config: MainConfig): ModuleWithProviders {
    return {
      ngModule: AteneaModule,
      providers: [
        { provide: MainConfig, useFactory: () => new MainConfig(config) },
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/atenea.module.ts